import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/_refactor/popup/popover/popover';
import useTicketCommentPopover from './use-ticket-comment-popover';
import { Ellipsis, Pencil, Trash } from 'lucide-react';
import { TTicketComment } from '../../types/ticket-comment.type';
import { memo } from 'react';

const TicketCommentPopover = memo(
  ({ ticketComment, ticketId }: { ticketComment: TTicketComment; ticketId: string }) => {
    const {
      // POPOVER
      isPopoverOpen,
      handleChangePopoverOpen,

      // HANDLERS
      handleEditComment,
      handleDeleteComment,
    } = useTicketCommentPopover();

    return (
      <Popover open={isPopoverOpen} onOpenChange={handleChangePopoverOpen}>
        <PopoverTrigger asChild>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            className="cursor-pointer p-[4px]"
          >
            <Ellipsis className="w-[14px] h-[14px] flex-shrink-0 cursor-pointer text-[#25151E]" />
          </div>
        </PopoverTrigger>
        <PopoverContent side="bottom" align="end" className="p-0 w-[148px]">
          <div className="flex flex-col">
            <div
              className="w-full text-start flex items-center gap-x-[8px] py-[8px] px-[12px] cursor-pointer hover:bg-[#F5F5F5] border-b border-[#D9D9D9]"
              onClick={(e) => {
                e.stopPropagation();
                handleEditComment(ticketComment);
              }}
            >
              <Pencil className="w-[14px] h-[14px] flex-shrink-0" />
              <span className="text-[12px] font-[400] text-[#25151E]">Edit Comment</span>
            </div>

            <div
              className="w-full text-start flex items-center gap-x-[8px] py-[8px] px-[12px] cursor-pointer hover:bg-[#CC0202]/10"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteComment(ticketComment, ticketId);
              }}
            >
              <Trash className="w-[14px] h-[14px] flex-shrink-0 text-[#CC0202]" />
              <span className="text-[12px] font-[400] text-[#CC0202]">Delete Comment</span>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    );
  }
);
TicketCommentPopover.displayName = 'TicketCommentPopover';
export default TicketCommentPopover;
